export default __webpack_public_path__ + "static/media/landing.817c9e9f.png";